import theme from '../../../ui/theme/'
const styles = {
  // AddressSection
  addressSection: {
    width: `calc(100% - 2rem)`,
    margin: theme => theme.spacing(3, 'auto'),
    pt: 2,
    px: 2,
    pb: 3,
    backgroundColor: 'neutral.lightest',
  },
  addressSectionIsDestination: {
    pt: 2,
    mt: 2.5,
    mb: 3,
  },
  addressSectionAddressWrapper: {
    mt: 2,
    display: 'flex',

    '& svg': {
      mr: 1,
      width: theme => theme.spacing(3),
      height: theme => theme.spacing(3),
      color: 'neutral.main',
    },
  },
  addressSectionAddress: {
    display: 'grid',
    gridTemplateRows: 'auto',
    gridRowGap: theme => theme.spacing(1),
  },
  addresSectionButtonWrapper: {
    mt: 2,
    ml: 4,
  },
  addresSectionDivider: {
    maxWidth: 20,
    mt: 2.5,
    mb: 2.5,
    ml: 0,
    backgroundColor: 'neutral.lighter',
  },

  // AddressEntry
  addressEntry: {
    px: 2,
  },
  addressEntryHidden: {
    display: 'none',
  },
  addressEntryNotConfirmed: {
    mb: 4,
  },
  addressEntryTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    mb: 3,
  },
  addressEntryButton: {
    mb: 3,
  },
  addressEntryAlert: {
    mt: 1,
  },
  addressEntryDestinationExtraInfoWrapper: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridColumnGap: theme => theme.spacing(2),
    my: 2,
  },
  addressEntryConfirmAddressButton: {
    mt: 3.625,
    mb: 4.25,
  },
  saveNewAddressCheckbox: {
    '&.MuiFormControlLabel-root': {
      alignItems: 'center',
    },
    '& .MuiCheckbox-root': {
      mt: 0,
      mr: 1.5,
    },
    '& .MuiTypography-root': {
      ...theme.typography.body2,
    },
  },

  // ContactAndShippingInfo
  contactAndShippingInfo: {
    px: 2,
  },
  contactAndShippingInfoTitle: {
    mb: 3,
  },
  contactAndShippingInfoSubtitle: {
    mb: 1.5,
  },
  contactAndShippingInfoPackagesInfoWrapper: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridColumnGap: theme => theme.spacing(2),
  },
  serviceType: {
    mb: 3,
    color: 'neutral.main',
  },

  // TextField
  textField: { mb: 2 },
  optionalLabel: { color: 'neutral.light' },

  circularProgress: { color: 'neutral.white' },
}

export default styles
